import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Entity } from '@app/app.model';
import { AppService } from '@app/app.service';
import { ActionsService } from '@app/_shared/actions/actions.service';
import { ErrorsService } from '@app/_shared/errors/errors.service';
import { SharedService } from '@app/_shared/shared.service';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import { cloneDeep } from 'lodash';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationGroupInterface, ConfigurationGroup } from './configuration-group.model';
import { ConfigurationGroupService } from './configuration-group.service';
import { dxDataGridHeightAdjustment } from '@app/common_helper';


@Component({
  selector: 'facnm-configuration-group',
  templateUrl: './configuration-group.component.html',
  styleUrls: ['./configuration-group.component.scss'],
  providers: [
    {
      provide: ConfigurationGroupInterface,
      useFactory: (httpClient: HttpClient, errors$: ErrorsService): any => {
        return new ConfigurationGroupService(httpClient, errors$);
      },
      deps: [HttpClient, ErrorsService]
    }
  ]
})
export class ConfigurationGroupComponent implements OnInit {

  constructor(
    private configurationGroup$: ConfigurationGroupInterface,
    private actions$: ActionsService,
    private errors$: ErrorsService,
    private app$: AppService,
    private shared$: SharedService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  @ViewChild('dataGrid', { static: true }) dataGrid: DxDataGridComponent;
  @ViewChild('entityForm') entityForm: NgForm;

  private dataGridAssignedVehicles: DxDataGridComponent;
  @ViewChild('dataGridAssignedVehicles', { static: false }) set assignedVehicles(content: DxDataGridComponent) {
    if (content) {
      this.dataGridAssignedVehicles = content;
    }
  }

  private dataGridUnassignedVehicles: DxDataGridComponent;
  @ViewChild('dataGridUnassignedVehicles', { static: false }) set unassignedVehicles(content: DxDataGridComponent) {
    if (content) {
      this.dataGridUnassignedVehicles = content;
    }
  }
  private unsubscribe$ = new Subject<void>();
  VCollapse = false;
  gridData: ArrayStore;
  isAddForm = 0;
  collapseColor = 'green';
  entityName = 'Configuration Group Management';
  entityNameNotification = "Configuration Group";
  entityData: Entity<ConfigurationGroup>;
  newEntityData: ConfigurationGroup;
  newEntity: any;
  assignedVehicleSelected = [];
  unassignedVehicleSelected = [];
  allMode: string;
  checkBoxesMode: string;
  vehicleColumnConfig: any;

  ngOnInit(): void {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'onClick';
    this.actions();
    this.getList();
    this.app$.setScreenTitle(this.entityName);
    forkJoin({
      newEntity: this.configurationGroup$.getEntity({ Id: 0 }),
    }).subscribe(
      res => {
        this.newEntityData = res['newEntity'];
      },
      (errorNetwork) => {
        this.errors$.handleServerErrors(errorNetwork);
      }
    );

    this.vehicleColumnConfig = [
      { caption: 'Vehicle Id', dataField: 'Id', visible: false, dataType: 'number' },
      {
        caption: 'Device Id - Name', dataField: 'DeviceId', cssClass: 'DeviceId', dataType: 'string', alignment: 'left',
        cellTemplate: function (container, options) {
          var devicedetails = "";
          if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
          if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
          $('<span />').text(devicedetails).append("</br>").appendTo(container);
        },
        calculateCellValue: function (data) {
          return data.DeviceId + " - " + data.DeviceName;
        },
        calculateFilterExpression: function (filterValue, selectedFilterOperation) {
          return [this.calculateCellValue, selectedFilterOperation || 'contains', filterValue];
        }
      },
      { alignment: 'center', caption: 'Vehicle No', dataField: 'VehicleNumber', cssClass: 'VehicleNumber', dataType: 'string' },
      {
        alignment: 'left', caption: 'License Plate', dataField: 'LicensePlate', cssClass: 'LicensePlate', dataType: 'string', width: 150,
        cellTemplate: function (container, options) {
          $('<span />')
            .text(options.data.LicensePlate)
            .appendTo(container);
        }
      }
    ];
  }

  actions() {
    this.configurationGroup$.ListRetrieved.subscribe(data => {
      if (data) {
        this.gridData = new ArrayStore({
          data: data,
          key: ['Id']
        });

        if (data.length == 0) {
          this.dataGrid.noDataText = 'No Configuration Groups Found';
        }
        else {
          this.dataGrid.noDataText = '';
        }
      }
    });

    this.actions$.EntityAdding.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.addNewEntity());
    this.actions$.EntityCreating.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.create(false));
    this.actions$.EntitySaving.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.create(true));
    this.actions$.EntityDeleteConfirmed.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.deleteConfirm());
    this.actions$.EntityResetting.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.reset());
    this.actions$.EntityCanceling.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.cancel());
    this.errors$.ServerErrorsReceived.pipe(takeUntil(this.unsubscribe$)).subscribe((errors) => {
      if (errors) {
        let entityForm = document.getElementById('entity-form');
        if (entityForm) {
          entityForm.scrollTop = 0;
        }
      }
    });
  }

  getList() {
    this.configurationGroup$.getList().subscribe(listWithCreated => {
      this.configurationGroup$.notifyRetrieved(listWithCreated);
      this.app$.notifyScreenReady();
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  private handleFormSubmit() {
    this.entityForm.form.markAsPristine();
    this.entityForm.form.markAsUntouched();
    this.entityForm.form.updateValueAndValidity();
  }

  create(isSave: boolean) {
    this.handleFormSubmit();
    this.entityForm.onSubmit(undefined);
    if (this.entityForm.form.invalid) {
      setTimeout(() => { this.app$.notifyScreenReady(); })
      return;
    }

    this.configurationGroup$.create(this.entityData).subscribe(
      (okCreate) => {
        this.app$.setScreenTitle(this.entityName);
        isSave ? this.actions$.notifySaved() : this.actions$.notifyCreated();
        this.deSelectEntity();
        this.getList();
        this.refreshGrid();
        this.app$.notifyScreenReady();
      },
      (errorCreate) => {
        this.errors$.handleServerErrors(errorCreate);
      }
    );
  }

  private deleteConfirm() {
    let param = { Id: this.entityData.value.Id };
    this.configurationGroup$.delete(param).subscribe(
      (okDelete) => {
        this.cancel();
        this.getList();
        this.actions$.notifyDeleted();
        this.app$.notifyScreenReady();
      },
      (errorDelete) => {
        this.errors$.handleServerErrors(errorDelete);
      }
    );
  }

  private addNewEntity() {
    this.app$.setScreenTitle('New ' + this.entityName);
    this.entityData = new Entity();
    this.entityData.value = cloneDeep(this.newEntityData);
    this.entityData.created = true;
    this.isAddForm = 1;
    this.collapseColor = 'yellow';
    this.clearAndRefreshGrid();
    this.changeDetectorRef.detectChanges();
  }

  assignVehicles() {
    let selectedRows = this.unassignedVehicleSelected;
    selectedRows.forEach(row => {
      let alreadyAssigned = this.entityData.value.AssignedVehicles.filter(a => a.DeviceId == row.DeviceId);
      this.entityData.value.UnassignedVehicles.splice(this.entityData.value.UnassignedVehicles.indexOf(row), 1);
      if (alreadyAssigned.length == 0) {
        this.entityData.value.AssignedVehicles.push(row);
      }
    });
    this.clearAndRefreshGrid();
  }

  unassignVehicles() {
    let selectedRows = this.assignedVehicleSelected;
    selectedRows.forEach(row => {
      let alreadyAssigned = this.entityData.value.UnassignedVehicles.filter(a => a.DeviceId == row.DeviceId);
      this.entityData.value.AssignedVehicles.splice(this.entityData.value.AssignedVehicles.indexOf(row), 1);
      if (alreadyAssigned.length == 0) {
        this.entityData.value.UnassignedVehicles.push(row);
      }
    });
    this.clearAndRefreshGrid();
  }

  clearAndRefreshGrid() {
    if (this.dataGridUnassignedVehicles && this.dataGridAssignedVehicles) {
      this.dataGridUnassignedVehicles.instance.clearSelection();
      this.dataGridUnassignedVehicles.instance.refresh();
      this.dataGridAssignedVehicles.instance.clearSelection();
      this.dataGridAssignedVehicles.instance.refresh();
      this.setNoDataText();
    }
  }

  onContentReadyGroup(e){
    this.dataGrid.noDataText = this.dataGrid.instance.totalCount() ? '' : "No Configuration Groups Found";
  }

  onContentReadyAssigned() {
    this.dataGridAssignedVehicles.noDataText = this.dataGridAssignedVehicles.instance.totalCount() ? '' : "No data";
  }

  onContentReadyUnAssigned() {
    this.dataGridUnassignedVehicles.noDataText = this.dataGridUnassignedVehicles.instance.totalCount() ? '' : "No data";
  }

  setNoDataText() {
    this.dataGridUnassignedVehicles.noDataText = this.entityData.value.UnassignedVehicles?.length ? '' : "No data";
    this.dataGridAssignedVehicles.noDataText = this.entityData.value.AssignedVehicles?.length ? '' : "No data";
  }

  private selectEntity(key: any) {
    this.app$.notifyScreenBusy();
    this.isAddForm = 0;
    this.collapseColor = 'green';
    this.configurationGroup$.getEntity(key).subscribe((res: any) => {
      this.app$.notifyScreenReady();
      this.entityData = new Entity();
      this.entityData.key = key;
      this.entityData.value = cloneDeep(res);
      this.unassignedVehicleSelected = [];
      this.assignedVehicleSelected = [];
      this.changeDetectorRef.detectChanges();
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  refreshGrid() {
    this.dataGrid.instance.refresh();
  }

  private deSelectEntity() {
    this.dataGrid.instance.deselectRows(this.entityData.key);
    this.entityData.key = undefined;
  }

  private reset() {
    this.entityData.restore();
    this.clearAndRefreshGrid();
  }

  private cancel() {
    this.app$.setScreenTitle(this.entityName);
    this.deSelectEntity();
  }

  onInitialized(e: any) {
    this.resizeScreenContent();
  }

  onRowClick($clikedRow: { key: any; }) {
    this.app$.setScreenTitle(this.entityName);
    if (!this.entityData) {
      this.entityData = new Entity();
      this.entityData.key = undefined;
    }

    if (JSON.stringify(this.entityData.key) === JSON.stringify($clikedRow.key)) {
      this.deSelectEntity();
    }
    else {
      this.selectEntity($clikedRow.key);
    }
  }

  collapseClass(pannel) {
    return {
      'collapsible-header-icon-green-up': !pannel && !this.isAddForm,
      'collapsible-header-icon-green-down': pannel && !this.isAddForm,
      'collapsible-header-icon-yellow-up': !pannel && this.isAddForm,
      'collapsible-header-icon-yellow-down': pannel && this.isAddForm,
    }
  }

  hasError(control) {
    return this.entityForm?.submitted && this.entityForm.form.get(control)?.errors;
  }

  checkError(control, type) {
    return this.entityForm.form.get(control).errors[type];
  }

  onResize(e: any): void {
    this.resizeScreenContent();
  }

  formHeight: string;
  @ViewChild('screen', { static: true }) screenElement: ElementRef;
  private resizeScreenContent() {
    let h = this.screenElement.nativeElement.clientHeight;
    this.formHeight = h - 80 + 'px';
    this.dataGrid.instance.option('height', h - dxDataGridHeightAdjustment);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
